Ext.define('SA.HistogramLocations', {
    singleton: true,

    isSupported({country, censusRelease, location}) {
        var location = SA.data.LocationsCache.toLocationSeries(location),
            locationUnit = SA.data.LocationsCache.getGeographicUnit(location),
            smallestUnit = SA.Array.getLast(SA.data.GeographicUnits.findIds({country, censusRelease})),
            notSmallestUnit = locationUnit !== smallestUnit,
            isInCensusRelease = SA.data.LocationsCache.locationAvailableInCensusRelease(location, censusRelease);

        return notSmallestUnit && isInCensusRelease;
    }
});